/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Error_DetailInputs */

const vi_import_error_detail = /** @type {(inputs: Import_Error_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi tiết lỗi`)
};

/**

* @param {Import_Error_DetailInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const import_error_detail = /** @type {((inputs?: Import_Error_DetailInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Error_DetailInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_import_error_detail(inputs)
});